import { logger, toaster } from "../../Utils"
import { postAPI } from '../../Api';

const log = logger("uploadSignedLeaseAPI")
export async function uploadSignedLeaseAPI(body, props) {
    let url = '/landlord/listing/lease/upload-signed-lease';
    return await postAPI(url, body);
}
